import { action, makeObservable } from "mobx";
import { FunctionComponent } from "react";
import CustomViewDialogStore from "../CustomViewDialogStore";
import { ICustomViewDropDownOptions, ICustomViewQueryOptions } from "./CustomViewOptions";
import CustomViewOptionsStore from "./CustomViewOptionsStore";

/**
 * This store contains information about all common query options
 */
export class CustomViewQueryOptionsStore<T extends ICustomViewQueryOptions = ICustomViewQueryOptions> extends CustomViewOptionsStore<T> {
	constructor(
		dropDownOptions: ICustomViewDropDownOptions,
		component: FunctionComponent,
		customViewDialogStore: CustomViewDialogStore,
		options?: T,
	) {
		super(dropDownOptions, component, customViewDialogStore, options);
		makeObservable(this);
	}

	/** set the value for disableAdHoc */
	@action setDisableAdHoc = (value: boolean): void => {
		this.options.disableAdHoc = value;
		if (value) {
			this.setSuspended(false);
		}
	};

	/** set the value for filterRemember */
	@action setFilterRemember = (value: boolean): void => {
		this.options.filterRemember = value;
	};

	/** set the value for showCountIfSuspended */
	@action setShowCountIfSuspended = (value: boolean): void => {
		this.options.showCountIfSuspended = value;
	};

	/** set the value for suspended */
	@action setSuspended = (value: boolean): void => {
		this.options.suspended = value;
		if (!value) {
			this.options.suspendedRequireFilter = false;
		}
	};

	/** set the value for suspendedRequireFilter */
	@action setSuspendedRequireFilter = (value: boolean): void => {
		//TODO: double check advanced logic going on when making changes to this option that affect others
		this.options.suspendedRequireFilter = value;
	};
}